import { PlayMode } from '../../enum/media-player/media-play-mode';
import { MediaPlayerState } from '../../enum/media-player/media-player-state';
import { MediaType } from '../../enum/media-player/media-type';
import { MediaContent } from './media-content';

export class MediaPlayerCurrentState {
  mediaType: MediaType | null;
  mediaContent: MediaContent | null;
  playerState: MediaPlayerState | null;
  progress: number | null;
  volume: number | null;
  preMuteVolume: number | null;
  isMuted: boolean | null;
  playMode: PlayMode | null;
  currentStreamTitle: string | null;
  currentStreamImageUrl: string | null;
  mediaFormat: string | null;
  audioChannels: number | null;
  bitrateFromSource: number | null;
  sampleFrequency: number | null;

  constructor(
    mediaType: MediaType | null,
    mediaContent: MediaContent | null,
    playerState: MediaPlayerState | null,
    progress: number | null,
    volume: number | null,
    preMuteVolume: number | null,
    isMuted: boolean | null,
    playMode: PlayMode | null,
    currentStreamTitle: string | null,
    currentStreamImageUrl: string | null,
    mediaFormat: string | null,
    audioChannels: number | null,
    bitrateFromSource: number | null,
    sampleFrequency: number | null
  ) {
    this.mediaType = mediaType;
    this.mediaContent = mediaContent;
    this.playerState = playerState;
    this.progress = progress;
    this.volume = volume;
    this.preMuteVolume = preMuteVolume;
    this.isMuted = isMuted;
    this.playMode = playMode;
    this.currentStreamTitle = currentStreamTitle;
    this.currentStreamImageUrl = currentStreamImageUrl;
    this.mediaFormat = mediaFormat;
    this.audioChannels = audioChannels;
    this.bitrateFromSource = bitrateFromSource;
    this.sampleFrequency = sampleFrequency;
  }
}
